<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="m-0">Offer services</h4>
      <div class="d-flex align-items-center">
        <el-input
          v-model="searchQuery"
          clearable
          placeholder="Search by name (ru/en)..."
          style="width: 300px"
          class="mr-3"
          @keyup.enter.native="applyFilters"
        />
        <el-select v-model="filterType" placeholder="Type" clearable style="width: 180px" class="mr-3">
          <el-option v-for="t in types" :key="t.value" :label="t.label" :value="t.value" />
        </el-select>
        <el-button type="primary" class="mr-2" @click="applyFilters">Filter</el-button>
        <el-button class="mr-3" @click="clearFilters">Clear</el-button>
        <router-link :to="{ name: 'offer-services-create' }" class="btn btn-primary create-btn">Create</router-link>
      </div>
    </div>

    <card>
      <el-table :data="servicesList" v-loading="loading" style="width: 100%">
        <el-table-column label="ID" prop="id" min-width="220" />
        <el-table-column label="Name (EN)" min-width="260">
          <template slot-scope="{ row }">
            <span>{{ row.name && (row.name.en || row.name.ru) || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Type" width="140">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="typeTag(row.type)">{{ row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Edit" width="90" align="center">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="editService(row.id)">Edit</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Delete" width="90" align="center">
          <template slot-scope="{ row }">
            <el-button size="mini" type="danger" @click="handleDelete(row)">Del</el-button>
          </template>
        </el-table-column>
      </el-table>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

const TYPES = [
  { label: "Medical", value: "medical" },
  { label: "Common", value: "common" },
  { label: "Implant", value: "implant" },
  { label: "Transfer", value: "transfer" },
  { label: "Accommodation", value: "accommodation" },
];

export default {
  data() {
    return {
      loading: false,
      filterType: "",
      searchQuery: "",
      types: TYPES,
    };
  },
  computed: {
    ...mapState("offerServices", ["servicesList"]),
  },
  methods: {
    ...mapActions("offerServices", ["getServices", "deleteService"]),
    async loadList() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterType) params.type = this.filterType;
        if (this.searchQuery) params.name = this.searchQuery;
        await this.getServices(params);
      } finally {
        this.loading = false;
      }
    },
    applyFilters() {
      this.loadList();
    },
    clearFilters() {
      this.filterType = "";
      this.searchQuery = "";
      this.loadList();
    },
    editService(id) {
      this.$router.push({ name: "offer-services-edit", params: { id } });
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`Delete service "${(row.name && row.name.en) || row.id}"?`, "Warning", {
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
          type: "warning",
        });
        this.loading = true;
        await this.deleteService(row.id);
        this.$notify({ type: "success", title: "Service deleted" });
        await this.loadList();
      } catch (e) {
        if (e !== "cancel") {
          this.$notify({ type: "warning", title: "Error deleting service" });
        }
      } finally {
        this.loading = false;
      }
    },
    typeTag(type) {
      const map = {
        medical: "success",
        implant: "warning",
        transfer: "info",
        accommodation: "",
        common: "info",
      };
      return map[type] || "info";
    },
  },
  created() {
    this.loadList();
  },
};
</script>

<style scoped>
.el-select {
  margin-bottom: 0;
}

.create-btn {
  height: 40px;
  display: inline-flex;
  align-items: center;
}
</style>
